import React, { useEffect, useState } from "react";
import shortUUID from "short-uuid";
import { CheckIcon, PlusIcon } from "../../assets/Icons";
import { useParams } from "react-router-dom";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { UPDATE_APPLICATION_ENDPOINTS, FETCH_ENVIRONMENTAL_VARIABLE_KEY_NAMES } from "../../apiClient/apiEndpoints";
// import { MenuItem } from "@mui/material";
import Select from "react-select";

const generateShortUUID = () => shortUUID.generate();

const order = {
  API_URL: 0,
  UNO_URL: 1,
  FRONTEND_URL: 2,
};

const EndpointVariable = ({
  editKeys = true,
  endpointURL = [],
  fetchURLS = () => {},
  hideFrontEnd = false,
  channelIdProp = "",
  applicationIdProp = ""
}) => {
  const [dataList, setDataList] = useState([]);
  const [removeIds, setRemoveIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const { channelId, applicationId, directoryId } = useParams();
  const [environmentVariableDropDown, setEnvironmentVariableDropDown] = useState([]);

  const fetchVariableNames = async () => {
    try {
      const response = await apiClient.get(`${SSO_URL}${FETCH_ENVIRONMENTAL_VARIABLE_KEY_NAMES}`);
      let data = response?.map((e) => {
        return {
          name: e,
          label: e,
        };
      });
      if (hideFrontEnd) {
        data = data?.filter((e) => e?.name != "FRONTEND_URL");
      } else {
        data = data?.filter((e) => e?.name == "FRONTEND_URL");
      }
      setEnvironmentVariableDropDown(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddClick = () => {
    setDataList([
      ...dataList,
      {
        id: null,
        type: "",
        url: "",
        editable: false,
        isPrimary: false,
        key: generateShortUUID(),
        channelId: channelId || channelIdProp,
        directoryId: directoryId,
        isDropDown: true,
      },
    ]);
  };

  const handleRemoveClick = (key, id) => {
    setRemoveIds((pre) => [...pre, id]);
    setDataList((prev) => prev.filter((item) => item.key !== key));
  };

  const handleMakePrimary = (key) => {
    setDataList((prev) =>
      prev.map((item) => {
        return {
          ...item,
          isPrimary: item.key === key ? true : false,
        };
      })
    );
  };
  const handleChange = (key, field, value) => {
    setDataList((prev) =>
      prev.map((item) => {
        if (item.key === key) {
          return {
            ...item,
            [field]: value,
          };
        } else {
          return item;
        }
      })
    );
  };

  const validateData = (data) => {
    let seenApiUrl = false;
    const filtered = data.filter((item) => {
      if (item.type.toLowerCase() === "api_url") {
        if (seenApiUrl) return false;
        seenApiUrl = true;
        return true;
      }

      if (item.type.trim() === "" || item.url == null || item.url == undefined || item.url.trim() == "") {
        return false;
      }
      if (item.type.trim().toLowerCase() === "frontend_url") {
        return item.url !== null && item.url !== undefined && item.url.trim() !== "";
      }

      return true;
    });
    return filtered;
  };

 const handleSave = async () => {
    if (loading) return;
    try {
      let _validateData = validateData(dataList);
      try {
        let bodyData = {
          data: _validateData,
          removeIds: removeIds,
        };

        setLoading(true);
        await apiClient.post(
          `${SSO_URL}${UPDATE_APPLICATION_ENDPOINTS}/${applicationId || applicationIdProp}`,
          bodyData
        );
        fetchURLS();
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }

      setLoading(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVariableNames();
    let arrangeUrl = endpointURL.sort((a, b) => order[a.type] - order[b.type]);
    const parsedList = arrangeUrl.map((item) => ({
      id: item?.id,
      type: item?.type,
      url: item?.url,
      editable: true,
      isPrimary: item?.isPrimary,
      key: generateShortUUID(),
      channelId: channelId || channelIdProp,
      directoryId: directoryId,
    }));
    setDataList(parsedList);
  }, [endpointURL]);

  return (
    <>
      <div className="variable-list ">
        <div className="parent">
          <div>Endpoint variable key</div>
          <div>Endpoint variable value</div>
        </div>

        {dataList.map((item, index) => {
          return item?.isDropDown ? (
            <div className="child" key={item.key}>
              <div style={{ height: "100%", marginTop: "1rem", height: "2.2rem" }}>
                <Select
                  value={environmentVariableDropDown.find((option) => option.name === item.type) || null}
                  placeholder="Select Endpoint Type"
                  options={environmentVariableDropDown}
                  getOptionLabel={(e) => e.label}
                  getOptionValue={(e) => e.name}
                  onChange={(e) => handleChange(item.key, "type", e.name)}
                  filterOption={(option, inputValue) =>
                    option?.data?.label?.toLowerCase()?.includes(inputValue?.toLowerCase())
                  }
                />
              </div>
              <div className="standardinput">
                <input
                  type="text"
                  disabled={item.editable}
                  value={item.url}
                  style={{ width: "100%", height: "100%", marginTop: "1rem", height: "2.2rem" }}
                  onChange={(e) => handleChange(item.key, "url", e.target.value)}
                />
              </div>
              <div className="edit-remove">
                <button onClick={() => handleChange(item.key, "editable", !item.editable)}>
                  {" "}
                  {item.editable ? "Edit" : "Lock"}{" "}
                </button>
                <button className="remove" onClick={() => handleRemoveClick(item.key, item.id)}>
                  Remove
                </button>
                {item.type === "FRONTEND_URL" && (
                  <button className={item.isPrimary ? "primaryUrl" : ""} onClick={() => handleMakePrimary(item.key)}>
                    Primary
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className="child" key={item.key}>
              <div className="standardinput">
                <input
                  type="text"
                  disabled={item.id || item.editable ? true : false}
                  value={item.type}
                  className="input form-control"
                  onChange={(e) => handleChange(item.key, "type", e.target.value)}
                />
              </div>
              <div className="standardinput">
                <input
                  type="text"
                  disabled={item.editable}
                  value={item.url}
                  className="input form-control"
                  onChange={(e) => handleChange(item.key, "url", e.target.value)}
                />
              </div>

              <div className="edit-remove">
                <button onClick={() => handleChange(item.key, "editable", !item.editable)}>
                  {" "}
                  {item.editable ? "Edit" : "Lock"}{" "}
                </button>
                <button className="remove" onClick={() => handleRemoveClick(item.key, item.id)}>
                  Remove
                </button>
                {item.type === "FRONTEND_URL" && (
                  <button className={item.isPrimary ? "primaryUrl" : ""} onClick={() => handleMakePrimary(item.key)}>
                    Primary
                  </button>
                )}
              </div>
            </div>
          );
        })}

        <div className="add-new mt-3 mb-5">
          {editKeys && (
            <button className="DefaultRedBtn" onClick={handleAddClick}>
              <PlusIcon />
              Add Variable
            </button>
          )}
        </div>

        <div className="footerbtn w-100 mt-5">
          <button className="cancel"> Cancel </button>
          {!loading ? (
            <button className="save" onClick={handleSave}>
              Save
            </button>
          ) : (
            <button className="loading save">
              {" "}
              <svg viewBox="25 25 50 50">
                {" "}
                <circle r="20" cy="50" cx="50"></circle>{" "}
              </svg>{" "}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default EndpointVariable;
